import React, { useEffect, useState } from "react";
import { GetRequest } from "../../repository/RequestMaker";
import moment from "moment";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faTrashCan, faEdit } from "@fortawesome/free-solid-svg-icons";
import "./Companies.css";

export default function SubscriptionList() {
  const [subscription, setSubscription] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchSubscription();
  }, []);

  const fetchSubscription = () => {
    setLoading(true);
    GetRequest("/get_subscription")
      .then((response) => {
        console.log(response);
        setSubscription(response);
        console.log(subscription);
        setLoading(false);
      })
      .catch((error) => {
        console.error("Failed to fetch subscription", error);
        setLoading(false);
      });
  };

  const formatDate = (dateString) => {
    return moment(dateString).format("YYYY-MM-DD HH:mm:ss");
  };

  return (
    <div className="companies-container">
      <div className="card-admin animated fadeInDown">
        <table>
          <thead>
            <tr>
              <th>Subscription ID</th>
              <th>User ID</th>
              <th>Plan ID</th>
              <th>Startdatum</th>
              <th>Nächste Zahlung</th>
            </tr>
          </thead>
          <tbody>
            {subscription.map((subscription) => (
              <tr key={subscription.id}>
                <td>{subscription.subscription_id}</td>
                <td>{subscription.user_id}</td>
                <td>{subscription.plan_id}</td>
                <td>{formatDate(subscription.start_time)}</td>
                <td>{formatDate(subscription.next_billing_time)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
